// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"07993ab3","38":"5f896337","46":"acb97973","73":"03f33495","184":"d43af07d","366":"ca2276a3","428":"f75c2b6c","453":"737f1210","495":"83ab34d8"}[chunkId] + ".chunk.js";
};